import { render, staticRenderFns } from "./InvoiceNewDocumentDialog.vue?vue&type=template&id=b238cd08&scoped=true"
import script from "./InvoiceNewDocumentDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceNewDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNewDocumentDialog.vue?vue&type=style&index=0&id=b238cd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b238cd08",
  null
  
)

export default component.exports